<template>
  <div class="read-more" :class="dynamicClass">
    <span v-if="!readMoreActivated">{{text.slice(0, 200)}}</span>    
    <span v-if="readMoreActivated" v-html="text"></span>
    <div v-if="text.length >= slice">
      <a @click="activateReadMore" v-if="readMoreActivated">Leggi meno</a>
      <a @click="activateReadMore" v-else>Leggi di più</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "nna-read-more",
    props: {
      text: {
        type: String,
        default: ''        
      },
      slice: {
        type: Number,
        default: 200
      },
    },
    data () {
      return {
        readMoreActivated: false
      }
    },        
    computed: {
      dynamicClass () {
        return {
        }
      },
    },
    methods: {
      activateReadMore(){
        this.readMoreActivated = !this.readMoreActivated
      },
    },
    mounted() {    
    },
  }
</script>

<style scoped>  
</style>


// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/ReadMore/ReadMore.vue